import React, { useState } from "react";
import img1 from "../assets/9.png";
import img2 from "../assets/10.png";
import img3 from "../assets/12.png";
import img4 from "../assets/13.png";
import img6 from "../assets/30.png";
import img5 from "../assets/14.png";

const Certification = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  const achievements = [
    {
      image: img1,
      title: "India Blockchain Week ",
      description: "IBW2024 Conference is the two-day headline conference anchoring an action-packed week of web3 events during December in Bangalore, India.",
      date: "2024",
    },
    {
      image: img2,
      title: "Unfold Hackathon",
      description: "Participated in Unfold2k24 Hackathon at Marriott, Bengaluru—an electrifying event filled with innovation, collaboration, and Web3 networking. ",
      date: "2024",
    },
    {
      image: img3,
      title: "GeekFest 2025",
      description: "Organized Technical workshop with 4 Domains! 7 speakers From 𝗔𝗜 𝘁𝗼 𝗪𝗲𝗯𝟯, 𝗖𝘆𝗯𝗲𝗿𝘀𝗲𝗰𝘂𝗿𝗶𝘁𝘆 𝘁𝗼 𝗖𝗼𝗺𝗽𝗲𝘁𝗶𝘁𝗶𝘃𝗲 𝗣𝗿𝗼𝗴𝗿𝗮𝗺𝗺𝗶𝗻𝗴, every session was packed with insights and laughter",
      date: "2023",
    },
    {
      image: img4,
      title: "HackVerse 2023",
      description: "Organized HackVerse 2k23 where Innovation Thrived! From coding marathons to groundbreaking ideas, Hackverse was a journey of creativity and collaboration wherein Aptos Retail was one of our sponsor, joining us in India's largest series of Web 3 Hackathons.",
      date: "2022",
    },
    {
      image: img6,
      title: "Builder's Qoneqt",
      description: "Builder's Qoneqt—the largest Web3 and AI conference in Chennai, hosted by 2:47 PM Studio!",
      date: "2022",
    },
    {
      image: img5,
      title: "DevFest ",
      description: "Attended Devfest conducted by GDG Cloud Mangalore, and it was an amazing experience! The event was packed with insightful sessions, hands-on learning, and great networking. ",
      date: "2023",
    },
  ];

  const handlePrevSlide = () => {
    setActiveSlide((prev) => (prev === 0 ? achievements.length - 1 : prev - 1));
  };

  const handleNextSlide = () => {
    setActiveSlide((prev) => (prev === achievements.length - 1 ? 0 : prev + 1));
  };

  // Determine what dots to show based on screen size
  const visibleDots = () => {
    return achievements.map((_, index) => (
      <button
        key={index}
        className={`h-2 rounded-full mx-1 focus:outline-none transition-all duration-300 ${
          activeSlide === index ? "w-4 bg-blue-600" : "w-2 bg-blue-300"
        }`}
        onClick={() => setActiveSlide(index)}
        aria-label={`Go to slide ${index + 1}`}
      />
    ));
  };

  return (
    <div className="min-h-screen bg-cyan-300 px-4 md:px-8 pb-8 overflow-hidden">
      <h2 className="text-3xl md:text-4xl lg:text-5xl pt-8 font-bold text-center mb-4 md:mb-8">
        EVENTS AND HACKATHONS
      </h2>

      {/* Card display area - responsive height */}
      <div className="relative w-full mx-auto mb-8">
        <div className="aspect-[3/4] md:aspect-[4/3] lg:h-[600px] w-full">
          {achievements.map((achievement, index) => (
            <div
              key={index}
              className={`absolute inset-0 w-full h-full transition-all duration-500 transform ${
                activeSlide === index
                  ? "translate-x-0 opacity-100 z-10"
                  : index < activeSlide
                  ? "-translate-x-full opacity-0 z-0"
                  : "translate-x-full opacity-0 z-0"
              }`}
            >
              <div className="bg-white w-full sm:w-[90%] md:w-[80%] mx-auto rounded-xl border-black border-2 shadow-lg p-3 md:p-6 h-full flex flex-col">
                <div className="relative flex-grow overflow-hidden">
                  <img
                    src={achievement.image}
                    alt={achievement.title}
                    className="w-full h-full object-cover border-black border-2 rounded-lg"
                  />
                </div>
                <div className="mt-3">
                  <h4 className="text-lg md:text-xl font-semibold mb-1 md:mb-2">{achievement.title}</h4>
                  <p className="text-gray-600 text-sm md:text-base line-clamp-3 md:line-clamp-none">{achievement.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation buttons */}
        <button
          onClick={handlePrevSlide}
          className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 z-20 bg-white/80 hover:bg-white text-blue-600 p-2 rounded-full shadow-md focus:outline-none"
          aria-label="Previous slide"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button
          onClick={handleNextSlide}
          className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 z-20 bg-white/80 hover:bg-white text-blue-600 p-2 rounded-full shadow-md focus:outline-none"
          aria-label="Next slide"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      {/* Mobile dots indicator */}
      <div className="flex justify-center my-4 md:hidden">
        {visibleDots()}
      </div>

      {/* Timeline - simplified for mobile, full for larger screens */}
      <div className="hidden md:block relative mx-4 md:mx-8 lg:mx-16 mt-8 mb-12">
        {/* Horizontal connecting line */}
        <div className="absolute top-1/2 left-0 w-full h-1 bg-blue-400 -translate-y-1/2" />

        {/* Dots and titles */}
        <div className="flex justify-between relative">
          {achievements.map((achievement, index) => (
            <div
              key={index}
              className="relative cursor-pointer group"
              onClick={() => setActiveSlide(index)}
            >
              {/* Dot */}
              <div className="relative z-10">
                <div
                  className={`w-3 h-3 md:w-4 md:h-4 rounded-full transition-all duration-300 border-2 ${
                    activeSlide === index
                      ? "bg-white border-blue-600 scale-125"
                      : "bg-white border-blue-400 group-hover:border-blue-500"
                  }`}
                />
              </div>

              {/* Title above dot */}
              <div className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 w-16 sm:w-20 md:w-24 lg:w-32">
                <p
                  className={`text-center text-xs md:text-sm font-medium transition-colors duration-300 truncate ${
                    activeSlide === index
                      ? "text-blue-600"
                      : "text-gray-600 group-hover:text-blue-500"
                  }`}
                >
                  
                </p>
              </div>
              
              {/* Year below dot (visible only on larger screens) */}
              <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2">
                <p className={`text-center text-sm md:text-sm font-medium ${
                  activeSlide === index ? "text-blue-600" : "text-gray-600"
                }`}>
                 {achievement.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Alternative mobile list view for timeline */}
      <div className="md:hidden mt-8">
        <div className="flex overflow-x-auto pb-4 space-x-3 px-2">
          {achievements.map((achievement, index) => (
            <button
              key={index}
              className={`flex-shrink-0 px-3 py-1 rounded-full text-sm transition-colors ${
                activeSlide === index 
                  ? "bg-blue-600 text-white" 
                  : "bg-white text-gray-600 border border-blue-300"
              }`}
              onClick={() => setActiveSlide(index)}
            >
              {achievement.title.length > 15 
                ? `${achievement.title.substring(0, 15)}...` 
                : achievement.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Certification;